var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Main"}},[_c('div',[_c('Main',{attrs:{"propsData":_vm.propsData}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }